export const SAVE_STEP10_ACTION = 'src/Step10/SEND_EMAIL_MAIL'
export const MESSAGE_STEP10_ACTION = 'src/Step10/MESSAGE_STEP10_ACTION'


// WEBPACK FOOTER //
// ./src/conteiners/Step10/constants.js